import { render, staticRenderFns } from "./PatientCheckConfig.vue?vue&type=template&id=6de8e388&scoped=true"
import script from "./PatientCheckConfig.vue?vue&type=script&lang=js"
export * from "./PatientCheckConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de8e388",
  null
  
)

export default component.exports